// extracted by mini-css-extract-plugin
export default {"dropdown":"lsf-dropdown","dropdown_align_left":"lsf-dropdown_align_left","dropdown_align_right":"lsf-dropdown_align_right","dropdown__trigger":"lsf-dropdown__trigger","before-appear":"lsf-before-appear","before-disappear":"lsf-before-disappear","appear":"lsf-appear","visible":"lsf-visible","disappear":"lsf-disappear","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380561
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  